import React from 'react';
import { ServiceOptions } from 'app/components';
import { FormIGPRScore } from 'app/components/Sections/IGPRScore';

export const IGPRView: React.FC = () => {
  return (
    <div
      style={{
        padding: '5.1vh 4rem',
        minHeight: 'calc(100vh - 19.77rem)'
      }}
    >
      <h1 style={{ textAlign: 'left', paddingBottom: '1rem' }}>iGPR Score</h1>
      <div style={{ paddingLeft: '0rem' }}>
        <ServiceOptions
          showUseOurApiVersion={true}
          styleOptions={{ paddingBottom: '0' }}
        />
      </div>
      <FormIGPRScore />
    </div>
  );
};
